var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"type":"button","disabled":_vm.start}},[_vm._v(_vm._s(_vm.tmpStr))])
}
var staticRenderFns = []

export { render, staticRenderFns }